<template>
  <progress
    v-if="!marketsAvailable || !sitesAvailable"
    class="progress is-small is-primary"
    max="100"
    >Fetching</progress
  >
  <div v-else class="upcoming">
    <div
      v-if="featuredMarket() !== null"
      class="currentmarket currentmarket-bg-2"
    >
      <div class="inside">
        <span class="livenow" v-if="new Date() < featuredMarket().scheduled"
          >Live in {{ timeSince(new Date(), featuredMarket().scheduled) }}</span
        >
        <span class="livenow" v-else-if="isLive(featuredMarket())"
          >LIVE NOW</span
        >

        <router-link :to="'/market/' + featuredMarket().saleId" class="subtitle"
          ><h1 class="title">
            {{ featuredMarket().saleDescription }}
          </h1></router-link
        >
        <p>
          {{ marketToSite(featuredMarket()).sitename }} |
          {{ marketToSite(featuredMarket()).location }}
        </p>
        <p><strong>3,306 head</strong></p>
        <br />
        <p class="control">
          <a
            class="button is-white is-large"
            :href="'https://' + marketToSite(featuredMarket()).mediaServer"
          >
            WATCH LIVE&nbsp;
            <span class="icon">
              <i class="zmdi zmdi-arrow-right"></i>
            </span>
          </a>
        </p>
      </div>
    </div>
    <div class="currentmarket">
      <h2 class="title">Upcoming Auctions</h2>
      <div class="columns" v-for="(market, index) in markets" :key="index">
        <div class="column is-narrow is-hidden-touch">
          <figure>
            <p class="image is-64x64">
              <img
                :src="
                  'https://my.biddingmate.com.au/logos/' + market.site + '.png'
                "
                style="border-radius:10rem"
                :alt="marketToSite(market).sitename"
              />
            </p>
          </figure>
        </div>
        <div class="column">
          <div class="content">
            <p>
              <router-link :to="'/market/' + market.saleId" class="subtitle">{{
                market.saleDescription
              }}</router-link>
              <br />
              <small
                >{{ marketToSite(market).location }} |
                {{ market.scheduled.toLocaleString() }}</small
              >
            </p>
          </div>
        </div>
        <div class="column is-narrow">
          <a
            class="button is-success is-radiusless"
            v-on:click="getICS(market)"
            download
            >SET REMINDER</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.currentmarket {
  border-radius: 12px;
  padding: 2rem;
  overflow: hidden;
  position: relative;
}

.currentmarket-bg {
  opacity: 0.6;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: auto;
}

.currentmarket-bg-2 {
  background-image: url('~@/assets/Prostock-Hero-Cattle-transparent.webp');
  background-position: center;
  background-size: cover;
  /* background-attachment: fixed; */
}

.currentmarket .inside {
  position: relative;
}

.currentmarket .subtitle {
  font-weight: bold;
}

.currentmarket hr {
  border: 2px solid #363a45;
}
</style>

<script>
import log from 'loglevel'
import { icsFormatter } from '../ics'
import proapps from '../common/proapps'

export default {
  name: 'Home',
  metaInfo: {
    title: 'Market List',
    meta: [
      { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
      { name: 'description', content: 'Market lists' }
    ]
  },
  components: {},
  data() {
    return {
      marketUpdateInterval: null,
      marketsAvailable: false,
      sitesAvailable: false,
      markets: [],
      sites: []
    }
  },
  mounted() {
    log.info('Home mounted')

    let get = () => {
      // Get sites
      proapps
        .getSites()
        .then(response => {
          this.sites = response
          this.sitesAvailable = true
        })
        .catch(err => {
          log.error(err)
        })

      // Get markets
      let today = new Date()
      today.setHours(0, 0, 0, 0)
      proapps
        .getMarkets(undefined, undefined, today.toISOString())
        .then(response => {
          let markets = response
          markets = markets.filter(market => {
            return (
              market.scheduled > new Date() || this.isToday(market.scheduled)
            )
          })
          markets = markets.filter(market => {
            return !(market.timeFinished < new Date())
          })
          this.markets = markets.sort((a, b) => {
            return a.scheduled.getTime() - b.scheduled.getTime()
          })
          this.marketsAvailable = true
        })
        .catch(err => {
          log.error(err)
        })
    }
    get()
    this.marketUpdateInterval = setInterval(get, 10000)
  },
  destroyed() {
    clearInterval(this.marketUpdateInterval)
    log.info('Home destroyed')
  },
  methods: {
    getICS(market) {
      this.ics = icsFormatter()
      var begin = new Date(market.scheduled)
      var end = new Date(begin.getTime() + 60 * 60000)
      this.ics.addEvent(
        market.saleDescription,
        market.saleDescription,
        this.marketToSite(market).location,
        begin.toUTCString(),
        end.toUTCString()
      )
      this.ics.download(market.site, '.ics')
    },
    marketToSite(market) {
      let sites = this.sites.filter(function(f) {
        return f.site == market.site
      })
      if (sites.length > 0) {
        return sites[0]
      }

      return null
    },
    featuredMarket() {
      if (this.markets.length < 1) {
        return null
      }

      let ctx = this

      let current = this.markets.filter(function(f) {
        let scheduled = ctx.isToday(f.scheduled)
        // let now = new Date()
        // return f.timeStarted <= now && f.timeFinished >= now && scheduled
        return scheduled
      })
      if (current.length < 1) {
        return null
      }
      return current[0]
    },
    isLive(market) {
      // Check finish time is valid before using
      let stopSet =
        market.timeFinished instanceof Date &&
        !isNaN(market.timeFinished.valueOf())
      return (
        this.isToday(market.scheduled) &&
        market.timeStarted < new Date() &&
        (!stopSet ||
          market.timeFinished > new Date() ||
          market.timeFinished <= market.timeStarted)
      )
    },
    isToday(someDate) {
      const today = new Date()
      return (
        someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
      )
    },
    timeSince(start, stop) {
      var seconds = Math.floor((stop - start) / 1000)

      seconds = Number(seconds)
      var d = Math.floor(seconds / (3600 * 24))
      var h = Math.floor((seconds % (3600 * 24)) / 3600)
      var m = Math.floor((seconds % 3600) / 60)
      var s = Math.floor(seconds % 60)

      var dDisplay = d > 0 ? d + (d == 1 ? ' day ' : ' days ') : ''
      var hDisplay = h > 0 ? h + (h == 1 ? ' hour ' : ' hours ') : ''
      var mDisplay = m > 0 ? m + (m == 1 ? ' minute ' : ' minutes ') : ''
      var sDisplay = s > 0 ? s + (s == 1 ? ' second' : ' seconds') : ''
      if (d > 1) {
        return dDisplay
      } else if (d == 1) {
        return dDisplay + hDisplay
      } else if (h >= 1) {
        return hDisplay + mDisplay
      } else if (m == 1) {
        return mDisplay + sDisplay
      }
      return dDisplay + hDisplay + mDisplay + sDisplay
    }
  }
}
</script>
